import { render, staticRenderFns } from "./BlogListWidget.vue?vue&type=template&id=4bad4a16"
import script from "./BlogListWidget.vue?vue&type=script&lang=js"
export * from "./BlogListWidget.vue?vue&type=script&lang=js"
import style0 from "./BlogListWidget.vue?vue&type=style&index=0&id=4bad4a16&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports